module.exports = __webpack_public_path__ + "img/xy-b.d95beef9.png";